<template>
  <header>
    <div v-if="isImpersonated" class="c-impersonate-alert">
      <div class="o-wrapper o-wrapper--center">
        <span class="u-flexed-item--auto u-pull-left">You're impersonating a user, be careful! <strong>Your actions can not be undone</strong>.</span>
        <button @click="revertImpersonate" class="c-button c-button--small c-button--outline u-text-uppercase u-pull-right">Exit impersonation</button>
      </div>
    </div>
    <div class="u-bgcolor-base-base">
      <div class="o-wrapper o-wrapper--center">
        <section class="[ c-header-top o-gutter ]">

          <div class="[ c-header-top__box o-gutter ] u-flexed-item--auto">
            <div class="[ c-icon-label ]">
              <svgicon icon="phone" width="13px" height="13px"></svgicon>
              <div class="[ c-icon-label__content ]">
                <span class="u-medium">{{ $t('header.customer_service') }}:  +32(0)13/67.01.01</span> <br>
                <span class="u-font-tiny u-opacity-75">{{ $t('header.availability') }}</span>
              </div>
            </div>

            <v-product-search
              v-if="isCustomer"
              :can-add-group="false"
              @add-product-to-sheet="navigateToProduct"
              icon-svg-name="info"
              :placeholder="$t('global.search_bar_placeholder')"
              :show-label="false"
              :show-add-button="false"
              :close-on-click="true"
              type="global">
            </v-product-search>
          </div>

          <div class="c-header__actions u-flex-set">
            <div class="u-flex-set">

              <button @click="toggleClientVisibility"
                      type="button"
                      :class="{'c-button c-button--icon-only customer-visibility': true, 'is-customer-hidden': isCustomerHidden}"
                      v-tooltip="ClientToggleTooltip">
                <svg width="23px" height="13px" viewBox="0 0 23 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->
                  <desc>Created with Sketch.</desc>
                  <defs>
                    <polygon id="path-1" points="7.82801319e-16 6.33126519 7.82801319e-16 12.559322 22.0345593 12.559322 22.0345593 6.33126519 22.0345593 0.103208344 0 0.103208344"></polygon>
                  </defs>
                  <g id="Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Beheer-door-RA:-view-+-filter" transform="translate(-943.000000, -19.000000)">
                      <g id="HEADER" transform="translate(-1.000000, -2.000000)">
                        <g id="Balk-bovenaan">
                          <g id="Page-1" transform="translate(944.000000, 21.000000)">
                            <g id="Group-3" transform="translate(0.000000, 0.117198)">
                              <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1"></use>
                              </mask>
                              <g id="Clip-2"></g>
                              <path
                                d="M11.0171695,10.4676425 C8.67562712,10.4676425 6.77762712,8.5696425 6.77762712,6.22810013 C6.77762712,3.8867781 8.67562712,1.98855776 11.0171695,1.98855776 C13.3587119,1.98855776 15.2567119,3.88655776 15.2567119,6.22810013 C15.2567119,8.5696425 13.3587119,10.4676425 11.0171695,10.4676425 M22.0330169,6.18711708 C22.0325763,6.17786284 22.0316949,6.16904928 22.0310339,6.16001538 C22.0305932,6.15538827 22.0303729,6.15076115 22.0299322,6.14635437 C22.0292712,6.1397442 22.0281695,6.13313403 22.0272881,6.1267442 C22.0264068,6.11903233 22.0255254,6.11132047 22.0242034,6.10382894 C22.0239831,6.10294759 22.0237627,6.10184589 22.0237627,6.10096454 C21.996661,5.9306425 21.9164576,5.77089674 21.7935085,5.64772725 C21.0906271,4.81484589 20.2544407,4.07318488 19.4041525,3.39630352 C17.5729153,1.93721877 15.4785932,0.716540809 13.1667966,0.225184876 C11.830661,-0.0586117338 10.4861525,-0.0707303779 9.1429661,0.169439114 C7.92118644,0.388015385 6.74369492,0.842354368 5.64155932,1.40554081 C3.91652542,2.28689674 2.34110169,3.50206623 0.968389831,4.86442216 C0.714338983,5.11648996 0.461610169,5.37384589 0.230694915,5.64772725 C-0.0768983051,6.01216793 -0.0768983051,6.443812 0.230694915,6.80825267 C0.933576271,7.64135437 1.76976271,8.38257471 2.62005085,9.0596764 C4.45150847,10.5187611 6.54583051,11.7392188 8.85762712,12.230795 C10.1937627,12.514812 11.5384915,12.5269306 12.881678,12.2867611 C14.1032373,12.0681849 15.2807288,11.6138459 16.3830847,11.0506595 C18.1081186,10.1690832 19.6835424,8.95413403 21.0562542,7.5917781 C21.3103051,7.33948996 21.5630339,7.08235437 21.7939492,6.80847301 C21.9168983,6.68508318 21.9971017,6.5257781 22.0242034,6.35501538 C22.0242034,6.35435437 22.0244237,6.35325267 22.0246441,6.35237132 C22.0259661,6.34465945 22.0268475,6.33716793 22.0277288,6.32945606 C22.0286102,6.32284589 22.0297119,6.31645606 22.0303729,6.30984589 C22.0308136,6.30521877 22.0310339,6.300812 22.0314746,6.29618488 C22.0321356,6.28737132 22.0330169,6.27855776 22.0334576,6.26930352 C22.0341186,6.2556425 22.0345593,6.24198149 22.0345593,6.22810013 C22.0345593,6.21421877 22.033678,6.2007781 22.0330169,6.18711708"
                                id="Fill-1" fill="#FFFFFF" mask="url(#mask-2)"></path>
                            </g>
                            <path d="M11.0171695,5.04510169 C11.792322,5.04510169 12.4205085,5.67350847 12.4205085,6.44844068 C12.4205085,7.22359322 11.792322,7.85177966 11.0171695,7.85177966 C10.2420169,7.85177966 9.61383051,7.22359322 9.61383051,6.44844068 C9.61383051,5.67350847 10.2420169,5.04510169 11.0171695,5.04510169" id="Fill-4" fill="#FFFFFF"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>

              <v-modal ref="modal">
                <slot slot="title">{{$t('header.customer_is_watching.verification')}}</slot>
                <div class="o-wrapper o-wrapper--center">
                  <form action="" class="c-form c-form--horizontal">
                    <div class="u-max-700 c-form-row">
                      <v-form-row>
                        <p class="u-text-align-center u-color-base-dark">{{$t('header.customer_is_watching.enter_password_to_deactivate')}}</p>
                        <v-input v-model="password" :horizontal="false" type="password" name="password" :fluid="true" autocomplete="nope"></v-input>
                      </v-form-row>
                      <v-form-row>
                        <div class="c-form-item">
                          <v-label></v-label>
                          <button @click.prevent="submitVerificationForm" class="c-button c-button--alpha">{{$t('header.customer_is_watching.send')}}</button>
                        </div>
                      </v-form-row>
                    </div>
                  </form>
                </div>
              </v-modal>

            </div>
            <div class="u-flex-set">
              <toggle ref="toggle" v-if="isLoggedIn" custom-class="u-flex-set u-pos-relative" custom-button-class="c-button c-toggle__button account-button" content-class="c-toggle__content account-content" icon="user" iconWidth="12" iconHeight="16">
                <slot slot="toggle-button">
                  {{ $t('header.manage') }}
                </slot>
                <div class="welcome">
                  <p v-if="user.firstName && user.firstName.length > 0 && user.firstName !== 'null'" class="welcome-text">{{ $t('header.welcome') }} {{ user.firstName }}</p>
                  <div v-if="user.firstName && user.firstName.length > 0 && user.firstName !== 'null'" class="welcome-line"></div>
                </div>
                <nav>
                  <ul class="c-nav c-nav--vertical c-nav--account">
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer || isMarketing || isPersoneel || isSalesman" class="no-border">
                      <router-link to="/customer/account/edit" class="account-items-top">{{ $t('header.menu.manage_account') }}</router-link>
                    </li>
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer || isMarketing || isPersoneel || isSalesman"class="no-border">
                      <router-link to="/customer/account/users" class="account-items">{{ $t('header.menu.manage_users') }}</router-link>
                    </li>
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer || isMarketing || isPersoneel || isSalesman" class="no-border">
                      <router-link to="/customer/account/addresses" class="account-items">{{ $t('header.menu.manage_addresses') }}</router-link>
                    </li>
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer || isMarketing || isPersoneel || isSalesman" class="no-border">
                      <router-link to="/customer/account/history" class="account-items">{{ $t('footer.order_history') }}</router-link>
                    </li>
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer || isMarketing || isPersoneel || isSalesman" class="no-border">
                      <router-link to="/customer/account/backorders" class="account-items">{{ $t('customer.account.backorders.title') }}</router-link>
                    </li>
                    <li @click="$refs.toggle.toggleState()" v-if="isCustomer" class="no-border">
                      <router-link to="/customer/account/invoices" class="account-items-bot">{{ $t('customer.account.invoices.title') }}</router-link>
                    </li>
                  </ul>
                  <div class="logout-div">
                    <svgicon class="svg-fill" name="logout" color="#EF7D01"></svgicon>
                    <a href="#" @click="logout" class="logout-link">{{ $t('header.logout') }}</a>
                  </div>
                </nav>
              </toggle>
            </div>
            <div class="u-flex-set">
              <toggle custom-class="u-flex-set u-pos-relative" custom-button-class="c-button c-toggle__button c-toggle--header">
                <slot slot="toggle-button">
                  {{ $t('active_language') }}
                </slot>
                <language-nav></language-nav>
              </toggle>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="o-wrapper o-wrapper--center">
      <section class="[ c-header-main o-gutter ]">

        <router-link :to="'/'+userRole"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link>

        <nav class="u-flexed-item--auto c-mainnav-wrapper">
          <ul class="[ c-mainnav ]">

            <!-- ADMIN -->
            <li v-if="isAdmin">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/pre-orders">{{ $t('header.menu.pre_orders.pre_orders') }}</router-link>
              <ul>
                <li>
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/pre-orders/customer-preorders">{{ $t('header.menu.pre_orders.customer_preorders') }}</router-link>
                </li>
                <li>
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/pre-orders/preorder-processing">{{ $t('header.menu.pre_orders.preorder_processing') }}</router-link>
                </li>
              </ul>
            </li>
            <li v-if="isAdmin">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/salesman/customer-list">{{ $t('header.menu.customer_list') }}</router-link>
            </li>
            <li v-if="isAdmin">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/notifications">{{ $t('header.menu.notifications') }}</router-link>
            </li>
            <li v-if="isAdmin">
              <a href="" class="[ c-mainnav__link ] e-link--base">{{ $t('header.menu.admin') }}</a>
              <ul>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/banners">{{ $t('header.menu.banners') }}</router-link>
                </li>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/branches">{{ $t('header.menu.branches') }}</router-link>
                </li>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/users">{{ $t('header.menu.users') }}</router-link>
                </li>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/countries">{{ $t('header.menu.countries') }}</router-link>
                </li>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/coupons">{{ $t('header.menu.coupons') }}</router-link>
                </li>
                <li v-if="isAdmin">
                  <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/sizeCharts">{{ $t('header.menu.size_charts') }}</router-link>
                </li>
              </ul>
            </li>
            <li v-if="isAdmin">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/admin/reports">{{ $t('header.menu.reports') }}</router-link>
            </li>

            <!-- SALESMAN -->
            <li v-if="isSalesman">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/salesman/pre-orders">{{ $t('header.menu.pre_orders.pre_orders') }}</router-link>
            </li>
            <li v-if="isSalesman">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/salesman/customer-list">{{ $t('header.menu.customer_list') }}</router-link>
            </li>

            <!-- CUSTOMER -->
            <li v-if="isCustomer || isPersoneel || isMarketing">
              <router-link class="[ c-mainnav__link ] e-link--base" :to="'/customer/shop' + customerFilters">{{ $t('header.menu.webshop') }}</router-link>
            </li>
            <li v-if="isCustomer">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/customer/pre-orders">{{ $t('header.menu.pre_orders.pre_orders') }}</router-link>
            </li>
            <li v-if="isCustomer || isPersoneel || isMarketing">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/customer/downloads">{{ $t('header.menu.downloads') }}</router-link>
            </li>
            <li v-if="isCustomer || isPersoneel || isMarketing">
              <router-link class="[ c-mainnav__link ] e-link--base" to="/customer/our-brands">{{ $t('header.menu.our_brands') }}</router-link>
            </li>

          </ul>
        </nav>

        <router-link v-if="isCustomer || isPersoneel || isMarketing" to="/contact" class="c-button c-button--alpha">{{ $t('header.contact') }}</router-link>

        <router-link v-if="isCustomer || isPersoneel" class="basket__wrapper u-pos-relative" to="/customer/basket">
          <shopping-cart></shopping-cart>
          <span v-if="basketCount"
                class="basket__count"
                :class="{'basket__count_100plus': basketCount > 99 && basketCount < 1000, 'basket__count_1000plus': basketCount > 999}">
            {{ basketCount }}
          </span>
        </router-link>

      </section>
    </div>
  </header>
</template>

<script>
  // Import ShoppingCart widget
  import Vue from 'vue';
  import VModal from '@/components/modal/Modal'
  import ShoppingCart from '@/components/ShoppingCart'
  import Search from '@/components/Search'
  import Toggle from '@/components/Toggle'
  import LanguageNav from '@/components/LanguageNav'
  import VProductSearch from '@/components/form/productSearch/ProductSearch'

  // Forms
  import VInput from '@/components/form/Input'
  import VFormRow from '@/components/form/Row'
  import VLabel from '@/components/form/Label'

  export default {
    components: {
      VModal,
      ShoppingCart,
      Search,
      Toggle,
      LanguageNav,
      VProductSearch,
      VInput,
      VFormRow,
      VLabel
    },
    created() {
      setInterval(() => {
        this.customerFilters = sessionStorage.getItem('customerFilters') ? sessionStorage.getItem('customerFilters') : "";
      }, 500);
      this.$store.dispatch('checkAuth').then(() => {
        if(this.$store.getters.userInfo.customerCurrencyCode === null) {
          this.$store.dispatch('logout');
          this.$router.push("/login");
        }
      });
      if (!this.basketCount && (this.isCustomer || this.isPersoneel || this.isMarketing)) {
        this.$store.dispatch("getBasket");
      }
    },
    data() {
      return {
        password: '',
        customerFilters: sessionStorage.getItem('customerFilters')
      }
    },
    computed: {
      isLoggedIn() {
        return this.$store.getters.isLoggedIn;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isSalesman() {
        return this.$store.getters.isSalesman;
      },
      isCustomer() {
        return this.$store.getters.isCustomer;
      },
      isPersoneel() {
        return this.$store.getters.isPersoneel;
      },
      isMarketing() {
        return this.$store.getters.isMarketing;
      },
      isImpersonated() {
        return this.$store.getters.isImpersonated;
      },
      isCustomerHidden() {
        return this.$store.getters.isCustomerHidden;
      },
      basketCount() {
        return this.$store.getters.getBasketCount;
      },

      user() {
        return this.$store.getters.userInfo;
      },
      userRole() {
        if (this.isAdmin) {
          return 'admin'
        } else if (this.isSalesman) {
          return 'salesman'
        } else {
          return 'customer'
        }
      },

      userCreds() {
        return {
          grant_type: 'password',
          userName: this.user.userName,
          password: this.password
        }
      },

      ClientToggleTooltip() {
        return {
          content: this.isCustomerHidden ? this.$t('global.deactivate_customer_is_watching') : this.$t('global.activate_customer_is_watching'),
          classes: 'information'
        }
      }
    },
    methods: {
      logout(e) {
        e.preventDefault();
        sessionStorage.removeItem('customerFilters');
        this.$store.dispatch('logout');
        this.$router.push("/login");
      },
      revertImpersonate() {
        sessionStorage.removeItem('customerFilters');
        this.$store.dispatch('revertImpersonate').then((user) => {
          this.$store.dispatch('checkAuth');
          let url = user.Role === 'Admin' ? 'admin' : 'salesman';
          this.$router.push("/" + url)
        })
      },
      toggleClientVisibility() {
        if (this.isCustomerHidden) {
          this.$refs.modal.openDialog();
        } else {
          this.$store.dispatch('customerHidden').then(() => {
            this.$notify({
              group: 'global',
              title: this.$t('header.customer_is_watching.enabled'),
              type: 'success',
              duration: 4000
            });
          });
        }

      },
      submitVerificationForm() {
        this.$store.dispatch('disableCustomerIsWatching',
          {
            "password": this.password
          })
        .then(() => {

          this.$notify({
            group: 'global',
            title: this.$t('header.customer_is_watching.disabled'),
            type: 'success',
            duration: 4000
          });

          this.$refs.modal.closeDialog();
          this.password = '';

        }).catch((e) => {

          this.$notify({
            group: 'global',
            title: e.error_description,
            type: 'error',
            duration: 4000
          });

        });
      },
      navigateToProduct(productId, productGroupId, color) {
        this.$router.push({
          name: 'ProductDetailview',
          params: { id: productGroupId },
          query: { color: color }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

  // Import private settings & functions
  @import "~@/assets/scss/private";

  header {
    border-bottom: 1px solid rgba($color-base, .2);
    margin-bottom: em($global-spacing-unit-medium);
    position: relative;
    z-index: 5;
    @include down($desktop) {

    }
  }

  .c-header-main {
    display: flex;
    align-items: center;
    padding: em($global-spacing-unit-small) 0;
  }

  .c-mainnav {
    display: flex !important;
    flex-wrap: wrap !important;
    list-style: none;
    padding: 0;
    margin: 0;
    max-width: 100%;
    display: block;

    @include rfs($font-size-medium);

    @include down($desktop) {
      @include rfs($font-size-small);
    }

    li {
      position: relative;

      ul {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        transform: translateY(-2em);
        z-index: -1;
        transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;
        padding-left: 0;
        margin-left: 0;
        list-style-type: none;
        background-color: white;
        min-width: 240px;
        box-shadow: 1px 1px 3px 3px #efefef;

        li:hover {
          background: rgba(0, 0, 0, 0.06);
        }
      }

      &:focus ul,
      &:hover ul {
        visibility: visible;
        opacity: 1;
        z-index: 1;
        transform: translateY(0%);
        transition-delay: 0s, 0s, 0.3s;
      }
    }
  }

  .c-mainnav__link {
    padding: em($global-spacing-unit-small, $font-size-medium) em(15px, $font-size-medium);
    text-decoration: none;
    display: inline-block;
    font-style: italic;
    color: $color-base;
    border-bottom: 2px solid transparent;

    @include down($desktop) {
      padding: em($global-spacing-unit-tiny, $font-size-small) em(10px, $font-size-small);
    }

    &.router-link-active {
      color: $color-alpha;
      font-weight: $medium;
      text-decoration: underline;
    }
  }

  /**
   * Top header
   */
  .c-header-top {
    color: white;
    display: flex;

    .c-customer-search {
      color: $color-base;
      background-color: transparent;
      padding: 0;
      max-width: 400px;
      margin-left: 30px;

      @include rfs($font-size-small);
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      justify-content: center;
    }
  }

  .c-header-top__box {
    display: flex;
    padding: em($global-spacing-unit-tiny) 0;
    @include down($desktop) {
      max-width: 65%;
    }
  }

  .c-header__actions {
    > * {
      &:not(:last-child) {
        margin-right: -1px;
      }
    }

    @include down($desktop) {
      padding-left: 5px;
    }
  }

  .c-impersonate-alert {
    overflow: hidden;
    padding: 1.2em 0;
    background-color: $color-beta;
    z-index: 10;
    span {
      line-height: 30px;
      font-weight: 500;
    }
    .c-button.c-button--outline:hover {
      background-color: black;
      border-color: black;
    }
  }

  .customer-visibility {
    opacity: 0.3;
    box-shadow: none !important;

    &:hover,
    &:focus {
      color: transparent;
      background-color: transparent;
    }
  }

  .is-customer-hidden {
    opacity: 1;
  }

  .basket__wrapper {
    &:hover {
      opacity: 0.5;
    }
  }

  .basket__count {
    position: absolute;
    bottom: -10px;
    right: -17px;
    display: inline-block;
    width: 22px;
    height: 22px;
    font-size: 15px;
    text-align: center;
    background-color: $color-alpha;
    color: $color-white;
    text-decoration: none;
    border-radius: 50%;

    &.basket__count_100plus {
      bottom: -20px;
      right: -27px;
      width: 32px;
      height: 32px;
      line-height: 32px;
    }

    &.basket__count_1000plus {
      bottom: -28px;
      right: -40px;
      width: 45px;
      height: 45px;
      line-height: 45px;
    }
  }

  .c-logo {
    @include down($desktop) {
      width: 100px;
    }
  }

  .welcome {
    padding: em($global-spacing-unit) em($global-spacing-unit) em($global-spacing-unit-tiny) em($global-spacing-unit);
  }

  .welcome-text {
    margin-bottom: em($global-spacing-unit-small);
    font-weight: $medium;
    color: $color-neutral;
  }

  .welcome-line {
    border-bottom: solid 2px $color-alpha;
    width: em($global-spacing-unit);
  }

  .c-nav--account {
    padding: 0 em($global-spacing-unit) em($global-spacing-unit) em($global-spacing-unit);
    font-weight: $normal;
  }

  .no-border {
    border-bottom: none !important;
  }

  .account-items-top {
    padding: em($global-spacing-unit-tiny) 0 em($global-spacing-unit-tiny) 0;
  }

  .account-items {
    padding: 0 0 em($global-spacing-unit-tiny) 0
  }

  .account-items-bot {
    padding: 0;
  }

  .logout-div {
    border-top: 1px solid #F1F1F1;
    background-color: rgba(245, 245, 246, 0.25);
    padding: em($global-spacing-unit-small) em($global-spacing-unit);
  }

  .logout-link {
    text-decoration: none;
    color: $color-neutral;
    font-weight: $normal;
    margin-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue